<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    okText="授权"
    cancelText="取消"
    @ok="
      () => {
        $emit('ok')
      }
    "
    @cancel="
      () => {
        $emit('cancel')
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="项目">
          <a-select mode="multiple" v-decorator="['projectIds',{ rules: [{ required: true, message: '请选择项目' }] }]">
            <a-select-option v-for="d in projectList" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
const fields = ['projectIds']
export default {
  name: 'AuthorizeProject',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    projectList: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: '授权项目',
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    }
    return {
      form: this.$form.createForm(this),
    }
  },
  created() {
    console.log('custom modal created')

    // 防止表单未注册
    fields.forEach((v) => this.form.getFieldDecorator(v))

    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      console.log(this.model)
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted() {},
  methods: {},
}
</script>
